export const pillars = ['Hangeul', 'Prononciation', 'Vocabulaire', 'Routine'];
export const volumes = [{
  n: 1,
  emoji: '🧩',
  title: 'Le Hangeul Expliqué Sans Complications',
  desc: 'Comprenez comment l’alphabet coréen fonctionne clairement et étape par étape, afin que vous puissiez lire et écrire avec confiance — même si vous n’avez jamais étudié le coréen auparavant.'
}, {
  n: 2,
  emoji: '🎤',
  title: 'La Prononciation de Base qui Sonne Réellement Juste',
  desc: 'Apprenez à produire les sons essentiels et évitez les erreurs les plus courantes que font les francophones, même si vous n’avez jamais étudié de langue.'
}, {
  n: 3,
  emoji: '🗣️',
  title: 'De Vraies Phrases et Expressions Quotidiennes',
  desc: 'Intégrez le vocabulaire essentiel et les expressions qui apparaissent réellement dans les K-Dramas, afin que vous puissiez utiliser la langue dans des situations réelles dès la première semaine.'
}, {
  n: 4,
  emoji: '📅',
  title: 'Routine de 60 Minutes Avec Progrès Visible',
  desc: 'Suivez un plan facile pour avancer sans vous perdre, mesurez votre progrès avec des étapes claires et maintenez votre motivation élevée jusqu’au jour 60.'
}, {
  n: 5,
  emoji: '🎬',
  title: 'Comprenez les K-Dramas & K-Pop (Enfin)',
  desc: 'À la fin de 60 minutes, vous captez déjà 30-40% du dialogue sans sous-titres et comprenez les paroles des chansons comme jamais auparavant.'
}, {
  n: 6,
  emoji: '💬',
  title: 'Rejoignez la Communauté K avec Confiance',
  desc: 'Faites de vrais amis coréens, participez aux communautés de fans et ayez votre première vraie conversation en coréen sans geler.'
}];
export const volumeIncludes = ['Leçons visuelles étape par étape', 'Romanisation + traduction', 'Exercices de prononciation', 'Exemples réels de K-Drama', 'Listes de contrôle de pratique quotidienne', 'Feuilles d’examen imprimables', 'Conçu pour les débutants absolus', 'Prêt à appliquer dès aujourd’hui'];
export const bonuses = [{
  n: '01',
  title: 'Dictionnaire Visuel Hangeul-Français™ 📖',
  desc: '+300 mots essentiels organisés par catégories (aliments, voyage, famille, émotions, shopping). Chaque mot avec image, romanisation et phrase d’exemple de K-Drama réel. Votre référence instantanée — jamais plus besoin de traducteur.',
  price: '80€',
  cover: 'https://cdn.magicpatterns.com/uploads/2rQFY2PRZKQnRjqpqds2rp/BONO_1.png'
}, {
  n: '02',
  title: 'Reconnaissance en Contexte — Mots Avancés™ 🎯',
  desc: '80+ mots complexes présentés dans des phrases réelles extraites de K-Dramas et réseaux sociaux coréens. Apprenez le slang authentique et les expressions modernes que les Coréens utilisent vraiment. Décodez le coréen naturel, pas juste des mots isolés.',
  price: '60€',
  cover: 'https://cdn.magicpatterns.com/uploads/pAATwDZSAPjcMpjZqYiJ3c/BONO_2.png'
}, {
  n: '03',
  title: 'Prononciation — Natifs Coréens™ 🎧',
  desc: "Maîtrisez chaque son coréen grãce à la\nvisualisation articulatoire - où placer la\nlangue, comment bouger les lèvres,\ncombien d'air utiliser.",
  price: '70€',
  cover: 'https://cdn.magicpatterns.com/uploads/tWo7eznV3MuLXW8u8Rzuhy/BONO_3.png'
}, {
  n: '04',
  title: "Fiche Récapitulative K-Drama - Phrases Indispensables™ 🎬",
  desc: "Les phrases que vous entendrez dans TOUS les K-Dramas populaires. Amour, drame, humour, mystère — tout ce qui compte. Chacune avec contexte, variante formelle/informelle et l’épisode où elle apparaît. Commencez à reconnaître les vraies conversations instantanément.",
  price: '25€',
  cover: 'https://cdn.magicpatterns.com/uploads/65HEwnSYwQKnYNJJ9AdQNB/BONO_4.png'
}, {
  n: '05',
  title: 'Planning d’Étude Personnalisé + Excel™ 📊',
  desc: 'Système complet de suivi interactif pour mesurer votre progrès objectivement. Défis hebdomadaires structurés, journal de motivation guidé, modèle Excel automatique avec graphiques en temps réel. Voyez votre transformation en données concrètes, pas en sensations vagues.',
  price: '15€',
  cover: 'https://cdn.magicpatterns.com/uploads/sUWMWQd4ya1wnTSHxEvwee/BONO_5.png'
}];